export function getConsoleSubscriptionsUrl() {
  const consoleAppUrl = process.env.CONSOLE_APP_URL

  if (!consoleAppUrl) {
    console.error(
      '[navigateToConsoleSubscriptions] CONSOLE_APP_URL is not configured'
    )
    return undefined
  }

  return `${consoleAppUrl}/subscriptions`
}

export function navigateToConsoleSubscriptions() {
  const consoleSubscriptionsUrl = getConsoleSubscriptionsUrl()

  if (consoleSubscriptionsUrl) {
    window.location.href = consoleSubscriptionsUrl
  }
}
